import { render, staticRenderFns } from "./LffSeparator.vue?vue&type=template&id=13d1aed1&"
import script from "./LffSeparator.vue?vue&type=script&lang=js&"
export * from "./LffSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports